/*
author:wang.jiang 2016-1-16
 */
'use strict';
angular.module('editctrNewspaperTextModule', ['editctrNewspaperRouterModule'])
    .controller('EditctrNewspaperTextCtrl', ['$scope',
        'beforeonload',
        '$element',
        '$compile',
        '$window',
        '$state',
        '$timeout',
        '$location',
        '$anchorScroll',
        '$stateParams',
        '$validation',
        '$filter',
        'trsHttpService',
        'initPaperDataService',
        'jsonArrayToStringService',
        'modalDialog',
        '$q',
        'iWoService',
        'editingCenterService',
        'initeditctrBtnsService',
        'filterEditctrBtnsService',
        'initDataNewspaperService',
        'newsDictionBtnService',
        'newsEditBtnService',
        'storageListenerService',
        'editIsLock',
        'editcenterRightsService',
        'ueditorService',
        'sensitiveWordCheckService',
        'newMediaService',
        'messagePublishService',
        function (
            $scope,
            beforeonload,
            $element, $compile,
            $window,
            $state,
            $timeout,
            $location,
            $anchorScroll,
            $stateParams,
            $validation,
            $filter,
            trsHttpService,
            initPaperDataService,
            jsonArrayToStringService,
            modalDialog,
            $q,
            iWoService,
            editingCenterService,
            initeditctrBtnsService,
            filterEditctrBtnsService,
            initDataNewspaperService,
            newsDictionBtnService,
            newsEditBtnService,
            storageListenerService,
            editIsLock,
            editcenterRightsService,
            ueditorService,
            sensitiveWordCheckService,
            newMediaService,
            messagePublishService
        ) {
            initStatus();
            initData();
            // 锚点切换开始
            $scope.goto = function (id) {
                $location.hash(id);
                $anchorScroll();
            };

            /**
             * [initStatus description] 初始化状态
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20
                };
                $scope.status = {
                    newsFormError: [],
                    data: {
                        meataInfo: {}
                    },
                    isawaitrevise: $state.params.isawaitrevise,
                    newsPaperInfo: {},
                    support: {
                        content: '' // 提交给辅助写作的纯文本
                    },
                    switch: 'manuscriptInfo', // 默认选中稿件信息
                    bitFaceTit: '查看痕迹',
                    sensitiveWordTit: '敏感词校验',
                    openBtn: true,
                    zhengwen: false,
                    isEditDraft: !!angular.isDefined($stateParams.papermetadataid), // 是否是编辑稿件
                    bigFaceSwitch: { status: false },
                    version: [],
                    copyVersion: [],
                    comment: {
                        comment: [],
                        voiceObj: {},
                        hasMore: false,
                        currPage: 1,
                    },
                    path: {
                        '-1': 'editingCenterIwoPersonalVersionTime',
                        '1': 'editingCenterAppPersonalVersionTime',
                        '2': 'editingCenterWebsitePersonalVersionTime',
                        '3': 'editingCenterPaperPersonalVersionTime',
                        '4': 'editingCenterWeixinPersonalVersionTime'
                    },
                    isCheckSensitiveWords: false,
                    heimaCheckTit: '错别字校对',
                    canChangeFace: false,
                    showVideoAudioDiv: false, // 初始化音视频所需的div
                    isFusionEditor: $state.current.name === 'fusionnews', // 是否来自融合编辑器
                    toggleSubTitle: true, // 默认展示文章肩题和副题
                    // 上版稿显示传稿按钮
                    isShowTrsDraft: $stateParams.newspapertype === '2' ? $stateParams.newspapertype : null,
                };
                $scope.data = {
                    userName: '',
                    additionalText: [], // 内容拓展
                    relNewsSelectedItems: [],
                    selectNewArray: [],
                    selectTagArray: [],
                    ownerSelectedItems: '',
                    KEYWORDS: [],
                    version: [],
                    copyVersion: [],
                    tag: {
                        hasChoose: false,
                        originalTag: [],
                        selectTag: [],
                    },
                    comment: {
                        comment: [],
                        voiceObj: {},
                        hasMore: false,
                        currPage: 1,
                    },
                    moveMethodName: {
                        0: 'moveDAIBIANDoc',
                        1: 'moveDAISHENDoc',
                        2: 'moveYIQIANFADoc'
                    },
                    path: {
                        '-1': 'editingCenterFusionPersonalVersionTime',
                        '1': 'editingCenterAppPersonalVersionTime',
                        '2': 'editingCenterWebsitePersonalVersionTime',
                        '3': 'editingCenterPaperPersonalVersionTime',
                        '4': 'editingCenterWeixinPersonalVersionTime'
                    },
                    versionName: {
                        '-1': 'iwoobjectversionid',
                        '1': 'appobjectversionid',
                        '2': 'wzobjectversionid',
                        '3': 'bzobjectversionid',
                        '4': 'wxobjectversionid'
                    },
                    selectedVideoArray: [], // 选择的视频
                };
                if ($scope.status.isFusionEditor) {
                    $scope.params = {
                        'serviceid': 'mlf_fusioncreate',
                        'methodname': 'getPaperFusionDoc',
                        'sourceDocId': $scope.data.sourceDocId || $stateParams.iwometadataid
                    };
                } else {
                    $scope.params = {
                        'serviceid': 'mlf_paper',
                        'methodname': 'queryViewDatas',
                        'MetaDataIds': $stateParams.papermetadataid,
                    };
                }
                $scope.list = initDataNewspaperService.initNewspaperNews();
                // 初始化按钮点击
                $scope.handleBtnClick = function (funname) {
                    eval('$scope.' + funname + '()');
                };
                // 初始化稿件体裁
                iWoService.initData().then(function (data) {
                    $scope.docgenre = [];
                    angular.forEach(data.DocGenre, function (data, key) {
                        $scope.docgenre.push({
                            value: data.desc,
                            name: data.value
                        });
                    });
                    initDocgenre();
                });
                emitCloseWindow();
                $scope.editFlag = {
                    media: 'newspaper',
                    docType: 'news',
                };
            }

            /**
             * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
             * @return {[type]} [description]
             */
            function emitCloseWindow() {
                editingCenterService.allAppCloseWindow($scope, { typeName: 'newsPaper', saveLocal: true });
            }

            /**
             * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
             * @param  {[type]}  key [description] 操作日志或流程版本的数据
             * @return {Boolean}     [description]
             */
            $scope.isShowVersion = function (key) {
                if (key === undefined) {
                    return false;
                } else {
                    for (var i in key) {
                        return true;
                    }
                    return false;
                }
            };

            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                $scope.status.showVideoAudioDiv = false;
                // 判断是否有修订完成权限
                if ($scope.status.isawaitrevise) {
                    editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function (rights) {
                        $scope.status.btnRights = rights;
                    });
                }
                if (!$scope.status.isFusionEditor) {
                    ($stateParams.papermetadataid ? initEditData() : initNewData()).then(function () {
                        beforeonload.beforeonloadAlert($scope);
                    });
                }
                // 融合编辑器下获取评审意见
                if ($stateParams.iwometadataid) {
                    getComment($stateParams.iwometadataid, $scope.status.comment.currPage);
                }
                storageListenerService.removeListener('newspaper');
                $scope.status.support.content = '党的十八大以来，以习近平同志为总书记的党中央高度重视党的新闻舆论工作。 从2013年出席全国宣传思想工作会议、发表重要讲话，到去年底视察解放军报社，习近平总书记多次对新闻舆论工作作出重要部署，强调要把党的新闻舆论工作做得更好，坚持正确导向，勇于改革创新，以正确的舆论引导人，激发全党全国各族人民团结奋斗的强大力量。 人民日报、新华社、中央电视台是重要的舆论阵地。一件件实物、一张张图片、一个个短片……习近平参观展览、听取介绍，对3家中央新闻单位近年来取得的发展进步给予充分肯定。 人民日报总编室夜班编辑平台是报纸的编辑中心、出版枢纽。习近平总书记来到这里看望一线编辑。“夜班到几点？”“每天最后谁定版？”“现在一共多少个版？”……习近平总书记认真了解有关情况。总书记对围拢过来的编辑记者说，人民日报是党的重要舆论阵地，适应变化，不断壮大，关键是要不忘初衷，坚定信念，在坚守新闻舆论阵地的同时坚持与时俱进，同时要加强人才队伍建设，永远朝着新的目标不断努力。 参观新华社“历史与发展”主题展览时，听说新华社建立了180多个海外分社，看到新华社已经用海事卫星、无人机等现代装备武装记者，总书记点头表示赞赏。他接过工作人员递过的手持视频直播云终端，拿在手里试拍，体验新华社记者的工作状态。看完展览，总书记边走边说，直观感受真是不一样，新华社事业取得了很大发展。 《新闻联播》已经创办38年，是中央电视台历史最为悠久的栏目。习近平走进联播演播室、导播间，同播出团队互动交流。编辑部主任李风告诉总书记，《新闻联播》是“字字千钧、秒秒政治、天天考试”，传播党的声音容不得一丝一毫疏漏。演播室里，播音员坐的椅子已显陈旧，但大家说，舍不得换。因为，几代联播播音员都是坐在这张椅子上播音，已成为优良传统的象征。总书记点头表示肯定。 下午座谈会上，习近平总书记强调，党的新闻舆论工作坚持党性原则，最根本的是坚持党对舆论工作的领导。党和政府主办的媒体是党和政府的宣传阵地，必须姓党。新闻舆论工作各个方面、各个环节都要坚持正确舆论导向。 19日上午，习近平来到负责采编内参稿件的新华社参编部。桌子上，摆放着各种内参刊物，习近平在听取基本情况介绍后对新华社编辑记者说，内参工作非常重要，做好内参工作要客观真实，要有高度责任心、使命感。我在地方工作时就比较重视内参工作，到中央工作后尤其重视，希望大家再接再厉。 座谈会上，习近平总书记再次对全国新闻工作者提出殷切期望：要深入开展马克思主义新闻观教育，引导广大新闻舆论工作者做党的政策主张的传播者、时代风云的记录者、社会进步的推动者、公平正义的守望者。 人民日报编辑范正伟以《让主流声音更加响亮有力》为题发言。他说，新闻舆论处于意识形态最前沿，在一些大是大非问题上，党报评论必须旗帜鲜明、激浊扬清，敢于交锋、勇于亮剑，总书记引用过陕北的一句话，“不要听蝲喇蛄叫就不种庄稼了”。总书记插话说：“这个话，不光是陕北说，河北也这么说，很生动。';
                $anchorScroll.yOffset = 63;
            }

            /**
             * [revise description] 修订
             * @return {[type]} [description]
             */
            $scope.revise = function () {
                save().then(function () {
                    var params = {
                        serviceid: 'mlf_papermodify',
                        methodname: 'paperModifyDocsFinished',
                        PaperDocIds: $state.params.papermetadataid
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        modalDialog.alertType('修订成功', '', 'success', false, function () {
                            storageListenerService.addListenerToNewspaper('xiuding');
                            $window.close();
                        }, '', 1500);
                    }, function () {
                        editIsLock.lockDraft($stateParams.papermetadataid);
                    });
                }, function () {
                    editIsLock.lockDraft($stateParams.papermetadataid);
                });
            };

            /**
             * [initEditData description]初始化编辑数据
             * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[type]} [description]
             */
            function initEditData(dealWithListFun) {
                var deferred = $q.defer();
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function (data) {
                    $scope.list = data[0] || data;
                    $scope.data.remarks = $scope.list.REMARKS;
                    document.title = $scope.list.TITLE = $scope.list.TITLE.split('<br />').join('\n');
                    // 获取评审意见
                    if (!$stateParams.iwometadataid) {
                        getComment($stateParams.papermetadataid, $scope.status.comment.currPage);
                    }
                    // 融合编辑器下处理list
                    if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                        dealWithListFun();
                    }
                    getVersion().then(function () {
                        return loadDirective();
                    }).then(function () {
                        $scope.status.showVideoAudioDiv = true;
                        deferred.resolve(data);
                    });
                });
                // 稿件加锁
                editIsLock.lockDraft($stateParams.papermetadataid);
                if (!$scope.status.isFusionEditor) {
                    // 获取查看痕迹按钮权限
                    editcenterRightsService.getRightsofBigFace($stateParams.paperid, 'paper.trace').then(function (data) {
                        $scope.status.bigFaceRights = !!data['paper.trace.chakan'] ? 'true' : 'false';
                    });
                    initBtn();
                }
                return deferred.promise;
            }

            /**
             * [initNewData description]初始化新建数据
             * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[type]} [description]
             */
            function initNewData(dealWithListFun) {
                var defer = $q.defer();
                $scope.list = initPaperDataService.initText();
                // 融合编辑器下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                loadDirective().then(function () {
                    $scope.status.showVideoAudioDiv = true;
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [save description] 保存稿件
             * @param  {[type]} type [description] 是否直接保存
             * @return {[type]}      [description]
             */
            $scope.save = function (type) {
                // 包含本地版本功能的稿件类型做了特殊处理，在进行其他操作时均先做此保存操作，以此来更新本地版本
                type = angular.isDefined(type) ? type : true;
                var defer = $q.defer();
                save(type).then(function () {
                    if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'newspapertext') {
                        if (type === true) {
                            editIsLock.lockDraft($stateParams.papermetadataid);
                        }
                        getVersion().then(function () {
                            var params;
                            if ($scope.status.isFusionEditor) {
                                params = {
                                    'serviceid': 'mlf_fusioncreate',
                                    'methodname': 'getPaperFusionDoc',
                                    'sourceDocId': $scope.data.sourceDocId || $stateParams.iwometadataid
                                };
                            } else {
                                params = {
                                    'serviceid': 'mlf_paper',
                                    'methodname': 'queryViewDatas',
                                    'MetaDataIds': $stateParams.papermetadataid
                                };
                            }
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                                .then(function (data) {
                                    data = data[0] || data;
                                    var ue = UE.getEditor('ueditor');
                                    ue.ready(function () {
                                        ue.setContent(data.HTMLCONTENT);
                                        ueditorService.saveToLocal($scope.list.METADATAID, 'newsPaper', data.HTMLCONTENT, $scope.data.lastVersionid);
                                        defer.resolve();
                                    });
                                }, function () {
                                    defer.resolve();
                                });
                        });
                    } else {
                        getVersion().then(function () {
                            ueditorService.saveToLocal($scope.list.METADATAID, 'newsPaper', $scope.list.HTMLCONTENT, $scope.data.lastVersionid);
                        });
                        defer.resolve();
                    }
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            };

            /**
             * [saveContent description] 保存正文
             * @return  {[type]}  [return description]
             */
            function saveContent() {
                if (!$scope.status.isFusionEditor) {
                    ueditorService.saveContent($scope.list);
                }
            }

            /**
             * [save description]
             * @param   {[type]}  flag  [flag description] 保存
             * @return  {[type]}        [return description]
             */
            function save(flag) {
                saveContent();
                var deferred = $q.defer();
                $timeout(function () {
                    $validation.validate($scope.newsForm.authorForm);
                    $scope.newsForm.$pending = {};
                    $validation.validate($scope.newsForm)
                        .success(function () {
                            sensitiveWordCheckService.sensitiveWords($scope).then(function (sensitiveWords) {
                                $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                $scope.list.SENSITIVEWORDS = sensitiveWords;
                                if (angular.isDefined($scope.list.EXTPROPERTY)) {
                                    $scope.list.EXTPROPERTY.SENSITIVEWORDS = sensitiveWords;
                                } else {
                                    $scope.list.EXTPROPERTY = {
                                        SENSITIVEWORDS: sensitiveWords
                                    };
                                }
                                $scope.newsForm.$setPristine();
                                $scope.status.openBtn = false;
                                $scope.list.DOCRELTIME = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm').toString();
                                var list = angular.copy($scope.list);
                                // 标题回车处理成</br> 存入数据库里
                                list.TITLE = list.TITLE.split('\n').join('<br />');
                                list.ObjectId = $stateParams.papermetadataid;
                                list.CONTRIBUTORSAUTHER = $scope.data.userName;
                                delete list.CRDEPT;
                                delete list.DOCTYPE;
                                delete list.LOG_OPERATION;
                                delete list.OBJ_VERSION;
                                // 处理发稿单作者信息空数据提交问题
                                if (angular.isDefined(list.FGD_AUTHINFO[0]) && (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')) {
                                    list.FGD_AUTHINFO = '[]';
                                }
                                list.ORIGINALTYPE = $scope.data.originType;
                                list.SPECIALDOC = $scope.data.specialDoc;
                                // 处理发稿单作者信息空数据提交问题
                                if ($scope.status.isFusionEditor) {
                                    delete list.ISNOPAYMENT;
                                    delete list.FGD_EDITINFO;
                                    delete list.FGD_AUTHINFO;
                                    delete list.DOCGENRE;
                                    // list.NEWSSOURCES = !$scope.list.NEWSSOURCES.SRCNAME ? '' : angular.copy($scope.list.NEWSSOURCES);
                                    list.METADATAID = $stateParams.papermetadataid || '0';
                                    list.serviceid = 'mlf_fusionpaper';
                                    list.methodname = 'saveFictitionsNewsDoc';
                                    list.SourceDocId = $scope.data.sourceDocId || $stateParams.iwometadataid;
                                } else {
                                    list.serviceid = 'mlf_paper';
                                    list.methodname = 'saveNewsDocument';
                                }
                                list = jsonArrayToStringService.jsonArrayToString(list);
                                list.HTMLCONTENT = list.HTMLCONTENT.replace(/_ueditor_page_break_tag_/g, "<hr class='pagebreak' noshade='noshade' size='5' style='-webkit-user-select: none;'>");
                                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(function (data) {
                                    $scope.status.openBtn = true;
                                    if ($scope.status.isFusionEditor) {
                                        $scope.list.METADATAID = data.METADATAID;
                                        $scope.params.MetaDataIds = data.METADATAID;
                                        $stateParams.papermetadataid = data.METADATAID;
                                    } else {
                                        $scope.list.METADATAID = data.METADATAID;
                                        $scope.params.MetaDataIds = data.METADATAID;
                                        $stateParams.papermetadataid = data.METADATAID;
                                    }
                                    if (flag) {
                                        modalDialog.saveModel('保存成功', '', 'success');
                                        if (!$scope.status.isFusionEditor) {
                                            storageListenerService.addListenerToNewspaper();
                                            $state.transitionTo($state.current, $stateParams, {
                                                reload: false
                                            });
                                        }
                                    }
                                    beforeonload.refresh($scope);
                                    deferred.resolve(data);
                                }, function (data) {
                                    $scope.status.openBtn = true;
                                    deferred.reject(data);
                                });
                            }, function () {
                                $scope.status.isCheckSensitiveWords = Math.random();
                                deferred.reject();
                            });
                        }).error(function () {
                            editingCenterService.checkSaveError($scope.newsForm, $element, $scope); // 定位输入错的表单位置
                            deferred.reject();
                        });
                });
                return deferred.promise;
            }

            /**
             * [theFormError description] 获取表单变化
             * @return {[type]} [description]
             */
            $scope.theFormError = function () { // 当表单发生变化时会进入方法
                var errorArray = [];
                for (var error in $scope.newsForm.$error) {
                    errorArray.push(error);
                }
                $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
                if ($scope.status.newsFormError.length != errorArray.length) { // 长度不相等说明表单errorname发生变化
                    $scope.status.newsFormError = errorArray;
                }
                return $scope.status.newsFormError; // 返回
            };

            /**
             * [toggleEditor description] 切换编辑器显隐
             * @return {[type]} [description]
             */
            $scope.toggleEditor = function () {
                $scope.status.zhengwen = !$scope.status.zhengwen;
                if ($scope.status.zhengwen) { // 隐藏编辑器
                    $('.body_manuscript_content').addClass('editorHidden');
                } else {
                    $('.body_manuscript_content').removeClass('editorHidden');
                }
            };
            // 不发稿费
            $scope.updateCKSelection = function () {
                $scope.list.ISNOPAYMENT === '1' ? $scope.list.ISNOPAYMENT = '0' : $scope.list.ISNOPAYMENT = '1';
            };
            // 稿件体裁
            $scope.draftType = function () {
                $scope.list.DOCGENRE = angular.copy($scope.GENREDOC).value;
            };

            /**
             * [initDocgenre description] 稿件体裁
             * @return  {[type]}  [return description]
             */
            function initDocgenre() {
                var deferred = $q.defer();
                $scope.loadingPromise = trsHttpService.httpServer('./editingCenter/properties/metadataEnum.json', {}, 'get').then(function (data) {
                    $scope.DOCGENRE = [];
                    angular.forEach(data.DocGenre, function (item, index) {
                        $scope.DOCGENRE.push({
                            value: item.value,
                            name: item.desc
                        });
                    });
                    deferred.resolve();
                });
                return deferred.promise;
            }

            /**
             * [politicalCommonSense description]正文政治常识校验
             * @return {[type]} [description]
             */
            $scope.politicalCommonSense = function () {
                editingCenterService.checkoutDraft(ueditorService.bindContent()).then(function (data) {
                    if (data.content[0].resultInfo.length > 0) {
                        var ue = UE.getEditor('ueditor');
                        ue.setContent(ueditorService.handlingSensitiveInf(data, ue.getContent()));
                    }
                });
            };

            /**
             * [loadDirective description] 动态加载
             * @return  {[type]}  [return description]
             */
            function loadDirective() {
                var defer = $q.defer();
                editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
                if ($stateParams.issave === undefined || $stateParams.issave === '0') {
                    LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                        var docTypeToUeditor = $scope.status.isFusionEditor ? 'newsPaper_Fusion' : 'newsPaper';
                        var ueditor = '<ueditor edit-flag="editFlag" versionid="data.lastVersionid" list="list" type="{{\'' + docTypeToUeditor + '\'}}" infullscreen="status.infullscreen" has-content="status.hasContent"></ueditor>';
                        ueditor = $compile(ueditor)($scope);
                        $element.find('ueditorLocation').append(ueditor);
                        var ue = UE.getEditor('ueditor');
                        $scope.status.support.content = $scope.list.CONTENT;
                        ue.ready(function () {
                            ue.addListener('keydown', function (type, event) {
                                if (event.keyCode === 13) {
                                    // 获取纯文本
                                    $scope.status.support.content = ue.getContentTxt();
                                }
                            });
                            defer.resolve();
                        });
                        var isDragPic = $scope.status.isFusionEditor ? 'false' : 'true';
                        var isDragVideo = 'true';
                        var isDragAudio = 'true';
                        var supportCreation = '<support-creation is-trs-check-menu="{{\'true\'}}" parent-status="status" big-face-switch="status.bigFaceSwitch" has-editor="true" is-news="true" media-type="{{\'3\'}}" is-check-sensitive-words="status.isCheckSensitiveWords" list="list" not-allow-drag-pic="' + isDragPic + '" not-allow-drag-video="' + isDragVideo + '" not-allow-drag-audio="' + isDragAudio + '" no-open-creation="true"></support-creation>';
                        supportCreation = $compile(supportCreation)($scope);
                        $element.find('supportcreation').append(supportCreation);
                        $scope.status.canChangeFace = true;

                    });
                } else {
                    defer.resolve();
                }
                if (!$scope.status.isFusionEditor) {
                    var draftList = '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}"  editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                        '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
                    draftList = $compile(draftList)($scope);
                    $element.find('editor').append(draftList);
                }
                return defer.promise;
            }

            /**
             * [getVersion description] 流程版本操作日志
             * @param   {[type]}  more  [more description]
             * @return  {[type]}        [return description]
             */
            function getVersion(more) {
                var deferred = $q.defer();
                editingCenterService.getEditVersionTime($stateParams.iwometadataid || $stateParams.papermetadataid, $scope.page, $scope.status.copyVersion).then(function (data) {
                    if (more) {
                        $scope.data.version = $scope.data.version.concat(data);
                    } else {
                        $scope.data.version = data;
                    }
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deferred.resolve();
                }, function () {
                    deferred.resolve();
                });
                return deferred.promise;
            }

            /**
             * [getLoadMore description]操作日志加载更多
             * @return {[type]} [description]
             */
            $scope.getLoadMore = function () {
                $scope.page.CURRPAGE++;
                getVersion('more');
            };

            /**
             * [getComment description] 获取评审意见
             * @param   {[type]}  id        [id description]
             * @param   {[type]}  currPage  [currPage description]
             * @return  {[type]}            [return description]
             */
            function getComment(id, currPage) {
                editingCenterService.getComment(id, currPage).then(function (data) {
                    if (angular.isDefined($scope.status.comment.comment[$scope.status.comment.comment.length - 1]) && $filter('date')($scope.status.comment.comment[$scope.status.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() == $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()) {
                        $scope.status.comment.comment[$scope.status.comment.comment.length - 1].times = $scope.status.comment.comment[$scope.status.comment.comment.length - 1].times.concat(data.comment[0].times);
                        data.comment.shift();
                    }
                    $scope.status.comment['comment'] = $scope.status.comment['comment'].concat(data.comment);
                    $scope.status.comment.hasMore = data.hasMore;
                    for (var i in data.voiceObj) {
                        $scope.status.comment.voiceObj[i] = data.voiceObj[i];
                    }
                });
            }

            /**
             * [getComment description]获取评审意见
             * @return {[type]} [description]
             */
            $scope.getLoadMoreComment = function () {
                $scope.status.comment.currPage += 1;
                getComment($stateParams.papermetadataid, $scope.status.comment.currPage);
            };

            /**
             * [initBtn description] 按钮权限
             * @return  {[type]}  [return description]
             */
            function initBtn() {
                if ($scope.status.isawaitrevise) { // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
                    addBtn();
                    return;
                }
                editingCenterService.getSiteInfo($stateParams.paperid).then(function (data) {
                    $scope.status.newInformation = data;
                    $scope.methodnameArray = ['paper.dyg', 'paper.jrg', 'paper.sbg', 'paper.yqg'];
                    $scope.dictionaryArray = [newsDictionBtnService.initStandDraftBtn(), newsDictionBtnService.initTodayDraftBtn(), newsDictionBtnService.initPageDraftBtn()];
                    $scope.newsArray = newsEditBtnService.initDraftArrays()[$stateParams.newspapertype];
                    if (angular.isDefined($stateParams.isfusion) || ($stateParams.newspapertype == 2 && $scope.status.newInformation.ISDUOJISHEN == 0)) {
                        $scope.newsArray.length = 1;
                    }
                    initeditctrBtnsService.initNewsData($scope.methodnameArray[$stateParams.newspapertype], $stateParams.paperid, $stateParams.channelid).then(function (data) {
                        initeditctrBtnsService.initBtns(data, $scope.dictionaryArray[$stateParams.newspapertype]).then((btns) => {
                            $scope.btnStatus = btns;
                            $scope.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.newsArray);
                            addBtn();
                        });
                    });
                });
                editcenterRightsService.initNewspaperListBtn('paper.sbg', $stateParams.paperid).then(function (data) {
                    $scope.status.hasHeimaRight = !!data['paper.sbg.check'] ? 'true' : 'false';
                });
            }

            /**
             * [addBtn description] 新增保存按钮
             * @return  {[type]}  [return description]
             */
            function addBtn() {
                $scope.arrayBtn = $scope.arrayBtn ? $scope.arrayBtn : [];
                $scope.arrayBtn.unshift({
                    RIGHTINDEX: 'save',
                    OPERDESC: '保存',
                    OPERNAME: '保存',
                    OPERFUN: 'save'
                });
                $scope.arrayBtn.push({
                    RIGHTINDEX: 'close',
                    OPERDESC: '保存并关闭',
                    OPERNAME: '保存并关闭',
                    OPERFUN: 'saveAndClose'
                });
            }

            /**
             * [savethenclose description] 保存并关闭
             * @return  {[type]}  [return description]
            */
            $scope.saveAndClose = function () {
                editingCenterService.saveAndClose($scope.save, 0);
            };

            /**
             * [newsDraftShangBan description] 上版操作
             * @return  {[type]}  [return description]
             */
            $scope.newsDraftShangBan = function () {
                newMediaService.shangBan($scope).then(() => {
                    $scope.save(false).then(() => {
                        messagePublishService.publish('doEditPageOperation');
                    });
                });
            };

            /**
             * [newsDraftDaiYong description] 待用操作
             * @return  {[type]}  [return description]
             */
            $scope.newsDraftDaiYong = function () {
                newMediaService.daiYong($scope).then(() => {
                    $scope.save(false).then(() => {
                        messagePublishService.publish('doEditPageOperation');
                    });
                });
            };

            /**
             * [newsDraftZhuanBan description] 转版操作
             * @return  {[type]}  [return description]
             */
            $scope.newsDraftZhuanBan = function () {
                newMediaService.zhuanBan($scope).then(() => {
                    $scope.save(false).then(() => {
                        messagePublishService.publish('doEditPageOperation');
                    });
                });
            };

            /**
             * [newsDraftCheGao description] 撤稿操作
             * @return  {[type]}  [return description]
             */
            $scope.newsDraftCheGao = function () {
                newMediaService.newsPaperChegao($scope).then(() => {
                    $scope.save(false).then(() => {
                        messagePublishService.publish('doEditPageOperation');
                    });
                });
            };

            /**
             * [sendNews description] 传稿
             * @return  {[type]}  [return description]
             */
            $scope.sendNews = function () {
                newMediaService.newsChuanGao($scope).then(() => {
                    $scope.save(false).then(() => {
                        messagePublishService.publish('doEditPageOperation');
                    });
                });
            };

            /**
             * [newsDraftZhaoPai description] 签发照排
             * @return  {[type]}  [return description]
             */
            $scope.newsDraftZhaoPai = function () {
                $scope.save(false).then(() => {
                    editIsLock.lockDraft($state.params.papermetadataid);
                    newMediaService.newsSign($scope);
                });
            };

            /**
             * [openPersonalVersionTime description] 打开流程版本详情页
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.openPersonalVersionTime = function (item) {
                var path = $scope.data.path[item.MEDIATYPE];
                var params = {};
                if (!!$stateParams.iwometadataid) {
                    geRelatedversion($stateParams.iwometadataid, item.VERSIONNUM).then(function (data) {
                        var params = { // 融合
                            metadataid: $stateParams.iwometadataid,
                            iwoobjectversionid: item.OBJECTVERSIONID,
                            wzobjectversionid: angular.isDefined(data.web) ? data.web.objversionId : '',
                            bzobjectversionid: angular.isDefined(data.paper) ? data.paper.objversionId : '',
                            appobjectversionid: angular.isDefined(data.app) ? data.app.objversionId : '',
                            wxobjectversionid: angular.isDefined(data.wechat) ? data.wechat.objversionId : '',
                            versionum: item.VERSIONNUM,
                        };
                        item.url = $state.href(path, params);
                        var url = item.url;
                        $window.open(url);
                    });
                } else {
                    var objName = $scope.data.versionName[item.MEDIATYPE];
                    params[objName] = item.OBJECTVERSIONID;
                    params['metadataid'] = $stateParams.papermetadataid;
                    item.url = $state.href(path, params);
                    var url = item.url;
                    $window.open(url);
                }
            };

            /**
             * [geRelatedversion description] 融合稿获取关联流程版本
             * @param  {[type]} MetaDataId [description]
             * @param  {[type]} num        [description]
             * @return {[type]}            [description]
             */
            function geRelatedversion(MetaDataId, num) {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_fusionmyrelease',
                    methodname: 'getObjversionByDoc',
                    METADATAID: MetaDataId,
                    VersionNum: num
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            }

            /**
             * [getSuggestions description]获取suggestion
             * @param  {[str]} viewValue [description]输入框内输入值
             * @return {[type]}           [description]
             */
            $scope.getSuggestions = function (viewValue) {
                return editingCenterService.getRecentUsageSources(viewValue);
            };

            /**
             * [closeWindow description] 关闭页面
             * @return  {[type]}  [return description]
             */
            $scope.closeWindow = function () {
                let docTypeToUeditor = $scope.status.isFusionEditor ? 'newsPaper_Fusion' : 'newsPaper';
                $scope.closeWindow = function () {
                    editingCenterService.closeWindow(docTypeToUeditor, $scope);
                };
            };

            /* 融合编辑器额外功能开始*/
            if ($scope.status.isFusionEditor) {

                /**
                 * [pageCantEdit description] 已提交渠道编辑页不能编辑
                 * @param  {[type]} type [description] 稿件信息或属性信息
                 * @return {[type]}      [description]
                 */
                $scope.pageCantEdit = function (type) {
                    $timeout(function () {
                        if (type == 'manuscriptInfo') {
                            var manuHeight = $('.newspaper_manuscript_info').height();
                            var manuWidth = $('.newspaper_manuscript_info').width();
                            $('.pageCantEdit').find('.cantEditPart').height(manuHeight).width(manuWidth);
                            $('.newspaper_manuscript_info').resize(function () {
                                $('.pageCantEdit').find('.cantEditPart').height($(this).height());
                            });
                        } else if (type == 'attrInfo') {
                            var attrHeight = $('.newspaper_attr_info').height();
                            var attrWidth = $('.newspaper_attr_info').width();
                            $('.pageCantEdit').find('.cantEditPart').height(attrHeight).width(attrWidth);
                            $('.newspaper_attr_info').resize(function () {
                                $('.pageCantEdit').find('.cantEditPart').height($(this).height());
                            });
                        }
                    }, 300);
                };

                /**
                 * [initData description] 融合编辑器切换渠道时的初始化数据
                 * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
                 * @return {[type]} [description]
                 */
                $scope.initData = function (dealWithListFun) {
                    var defer = $q.defer();
                    if (angular.isDefined($stateParams.papermetadataid)) {
                        initEditData(dealWithListFun).then(function () {
                            defer.resolve();
                        });
                    } else {
                        initNewData(dealWithListFun).then(function () {
                            defer.resolve();
                        });
                    }
                    return defer.promise;
                };

                /**
                 * [loadFgd description] 加载发稿单
                 * @return {[type]} [description]
                 */
                $scope.loadFgd = function () {
                    var draftList = '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}"  editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                        '<editor-auth-dir originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0" author="list.FGD_AUTHINFO"></editor-auth-dir>';
                    draftList = $compile(draftList)($scope);
                    $element.find('editor').append(draftList);
                };

            }

            /* 融合编辑器额外功能结束*/

        }
    ]);
